import React, { ReactElement, useContext } from 'react'

import config from '@config'
import { useTranslation } from '@lib/i18n'
import type { SeatSelectionProps } from '@pages/Checkout/SeatSelection/index'
import Seats from '@pages/Checkout/SeatSelection/Seats'
import { FieldsetContext } from '@pages/context/fieldset'
import PluginSlot from '@plugins/Slot'
import { useParams } from '@stores/params'

import '@pages/Checkout/SeatSelection/legacy.scss'

const FallbackHeader = () => {
  const { t } = useTranslation()
  return <h3 className="mb-5">{t('extras.seats.title')}</h3>
}

const SeatSelection = ({ onSeatsError, isLoading }: SeatSelectionProps): ReactElement => {
  const { t } = useTranslation()
  const [{ marketingCarrierCode: carrierCode, retailerPartnerNumber }] = useParams()
  const isAvoidVacancy = config.amendments.avoidVacancy.byRpn.includes(retailerPartnerNumber)
  const requestEnabled = (carrierCode && config.seatAncillaryAsSelection?.[carrierCode]) || isAvoidVacancy
  const { isDisabled } = useContext(FieldsetContext)

  return (
    <div className="extras seats cell-12 column">
      <PluginSlot
        path="checkout.fieldsetHeader"
        props={{
          title: t('extras.seats.title'),
          index: 3,
        }}
        FallbackComponent={FallbackHeader}
      />
      <Seats isConnectionsLoading={isLoading} onError={onSeatsError} enabled={requestEnabled} disabled={isDisabled} />
    </div>
  )
}

export default SeatSelection
